import { useEffect, useRef } from 'react'

import styles from './styles.module.scss'

interface CheckboxProps {
  checked: boolean
  onChange: () => void
  label: string
  disabled?: boolean
  className?: string
  indeterminate?: boolean
}

const Checkbox = ({ checked, onChange, label, disabled = false, className, indeterminate = false }: CheckboxProps) => {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = indeterminate
  }, [indeterminate])

  return (
    <label className={`${styles.checkbox} ${className || ''}`}>
      <input ref={inputRef} type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
      <span>{label}</span>
    </label>
  )
}

export { default as CheckboxGroup } from './CheckboxGroup'
export default Checkbox
